import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Link} from 'react-router-dom';
import styles from './EvolutionRedirect.module.scss';

function EvolutionRedirect() {
  return (
    <section
      className={styles.evolutionRedirect}
      aria-label="Navegação entre seções"
    >
      <div className={styles.evolutionRedirectContent}>
        <div
          className={styles.activitiesSelected}
          role="status"
          aria-current="page"
        >
          <FontAwesomeIcon
            icon={['fad', 'book-open-cover']}
            color="#fff"
            size="lg"
            aria-hidden="true"
          />
          <span>Todas as Atividades</span>
        </div>

        <Link
          to="/evolucao"
          aria-label="Ir para página de Evolução e Comparação"
        >
          <FontAwesomeIcon
            icon={['fad', 'chart-simple']}
            color="#40357C"
            size="lg"
            aria-hidden="true"
          />
          Evolução e Comparação
        </Link>
      </div>
    </section>
  );
}

export default EvolutionRedirect;
